import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { Card, Skeleton } from "@mui/material";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { pulseSx, surfaceCardSx } from "@/components/screens/ServiceDashboard/components/styles";
import { ManagerialKpi } from "@/services/service-dashboard.service";

import VariationBadge from "../VariationBadge";

type Props = {
  title: string;
  attendedLabel: string;
  newLabel: string;
  attended: ManagerialKpi | undefined;
  newContacts: ManagerialKpi | undefined;
  caption: string;
  color: string;
  formatValue: (value: number) => string;
  isLoading?: boolean;
  isRefreshing?: boolean;
};

const MetricRow = ({
  label,
  kpi,
  caption,
  formatValue,
  isLoading,
}: {
  label: string;
  kpi: ManagerialKpi | undefined;
  caption: string;
  formatValue: (value: number) => string;
  isLoading?: boolean;
}) => (
  <MDBox display="flex" alignItems="flex-start" justifyContent="space-between" gap={1}>
    <MDBox minWidth={0}>
      <MDTypography variant="caption" color="text" fontWeight="medium" display="block">
        {label}
      </MDTypography>
      {isLoading ? (
        <Skeleton variant="text" height={28} width={56} />
      ) : (
        <MDTypography variant="h5" fontWeight="bold" lineHeight={1.2}>
          {kpi?.value === null || kpi?.value === undefined ? "--" : formatValue(kpi.value)}
        </MDTypography>
      )}
    </MDBox>
    <MDBox textAlign="right" pt={0.25}>
      <VariationBadge value={kpi?.variation} />
      <MDTypography variant="caption" color="text" display="block" lineHeight={1.2}>
        {caption}
      </MDTypography>
    </MDBox>
  </MDBox>
);

const ContactsTile = ({
  title,
  attendedLabel,
  newLabel,
  attended,
  newContacts,
  caption,
  color,
  formatValue,
  isLoading,
  isRefreshing = false,
}: Props) => (
  <Card sx={surfaceCardSx()}>
    <MDBox p={1.5} display="flex" gap={1.25} height="100%" sx={pulseSx(isRefreshing)}>
      <MDBox
        width="2.25rem"
        height="2.25rem"
        minWidth="2.25rem"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          borderRadius: "50% !important",
          backgroundColor: color,
          color: "#fff",
          "& svg": { fontSize: "1.2rem" },
        }}
      >
        <PeopleAltOutlinedIcon />
      </MDBox>
      <MDBox flex={1} minWidth={0} display="flex" flexDirection="column" gap={1}>
        <MDTypography
          variant="caption"
          fontWeight="medium"
          color="dark"
          sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {title}
        </MDTypography>
        <MetricRow
          label={attendedLabel}
          kpi={attended}
          caption={caption}
          formatValue={formatValue}
          isLoading={isLoading}
        />
        <MetricRow
          label={newLabel}
          kpi={newContacts}
          caption={caption}
          formatValue={formatValue}
          isLoading={isLoading}
        />
      </MDBox>
    </MDBox>
  </Card>
);

export default ContactsTile;
